module.exports = __webpack_public_path__ + "static/img/bg.3ef12e1f.jpg";